export default __webpack_public_path__ + "static/media/undraw_remotely_2j6y.c32d0b18.svg";